import dayjs from "dayjs"
import timezone from "dayjs/plugin/timezone"
import utc from "dayjs/plugin/utc"
import relativeTime from "dayjs/plugin/relativeTime"

dayjs.extend(utc)
dayjs.extend(timezone)

// Set default timezone to Asia/Bangkok
dayjs.tz.setDefault("Asia/Bangkok")

const isToday = (dateInput) => {
	const date = dayjs(dateInput)
	const today = dayjs()
	return date.format("YYYY-MM-DD") === today.format("YYYY-MM-DD")
}

const formatThaiBuddhistDate = (dateInput, format = "D MMM BB เวลา HH:mm น.") => {
	if (!dateInput) return ""

	const date = dayjs(dateInput)
	if (!date.isValid()) return "Invalid Date"

	// === ดึงข้อมูลจากวันที่ ===
	const day = date.date()
	const dayPadded = day.toString().padStart(2, "0")

	const monthIndex = date.month()
	const month = monthIndex + 1
	const monthPadded = month.toString().padStart(2, "0")

	const yearAD = date.year()
	const yearBE = yearAD + 543

	const hour = date.hour().toString().padStart(2, "0")
	const minute = date.minute().toString().padStart(2, "0")
	const second = date.second().toString().padStart(2, "0")
	const millisecond = date.millisecond().toString().padStart(3, "0")
	const dayOfWeek = date.day()
	const dayOfWeekNames = ["อาทิตย์", "จันทร์", "อังคาร", "พุธ", "พฤหัสบดี", "ศุกร์", "เสาร์"]
	const dayOfWeekNamesShort = ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."]
	const dayOfWeekName = dayOfWeekNames[dayOfWeek]
	const dayOfWeekNameShort = dayOfWeekNamesShort[dayOfWeek]

	// === ชื่อเดือนภาษาไทย ===
	const monthNamesFull = [
		"มกราคม",
		"กุมภาพันธ์",
		"มีนาคม",
		"เมษายน",
		"พฤษภาคม",
		"มิถุนายน",
		"กรกฎาคม",
		"สิงหาคม",
		"กันยายน",
		"ตุลาคม",
		"พฤศจิกายน",
		"ธันวาคม",
	]

	const monthNamesShort = ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."]

	// === แทนที่ Format Tokens ===
	return (
		format
			// Day
			.replace(/dddd/g, dayOfWeekName) // dddd = วันในสัปดาห์ เช่น อาทิตย์
			.replace(/ddd/g, dayOfWeekNameShort) // ddd = วันในสัปดาห์ย่อ เช่น อา.
			.replace(/DD/g, dayPadded) // DD = วันที่ 2 หลัก เช่น 07
			.replace(/D/g, day.toString()) // D = วันที่ไม่เติม 0 เช่น 7

			// Month
			.replace(/MMMM/g, monthNamesFull[monthIndex]) // MMMM = ชื่อเดือนเต็ม เช่น พฤษภาคม
			.replace(/MMM/g, monthNamesShort[monthIndex]) // MMM = ชื่อเดือนย่อ เช่น พ.ค.
			.replace(/MM/g, monthPadded) // MM = เดือนเลข 2 หลัก เช่น 05
			.replace(/M/g, month.toString()) // M = เดือนเลข ไม่เติม 0 เช่น 5

			// Year
			.replace(/BBBB/g, yearBE.toString()) // BBBB = พ.ศ. เต็ม เช่น 2568
			.replace(/BB/g, yearBE.toString().slice(-2)) // BB = พ.ศ. 2 หลัก เช่น 68
			.replace(/YYYY/g, yearAD.toString()) // YYYY = ค.ศ. เต็ม เช่น 2025
			.replace(/YY/g, yearAD.toString().slice(-2)) // YY = ค.ศ. 2 หลัก เช่น 25

			// Time
			.replace(/HH/g, hour) // HH = ชั่วโมง เช่น 13
			.replace(/mm/g, minute) // mm = นาที เช่น 45
			.replace(/ss/, second) // ss = วินาที เช่น 09
			.replace(/SSS/g, millisecond) // SSS = มิลลิวินาที เช่น 123
	)
}

function formatRelative(val) {
	if (!val) return ""
	const now = dayjs()
	const d = dayjs(val)
	if (!d.isValid()) return ""

	const diff = d.valueOf() - now.valueOf()
	const abs = Math.abs(diff)
	const isFuture = diff > 0
	const min = 60 * 1000,
		hour = 60 * min,
		day = 24 * hour
	let text = ""
	if (abs < min) text = "ไม่กี่วินาที"
	else if (abs < hour) text = `${Math.round(abs / min)} นาที`
	else if (abs < day) text = `${Math.round(abs / hour)} ชั่วโมง`
	else text = `${Math.round(abs / day)} วัน`
	return isFuture ? `เหลืออีก ${text}` : `${text}ที่แล้ว`
}

function formatDateTimeWithRelative(val, format) {
	const dateStr = formatThaiBuddhistDate(val, format)
	const rel = formatRelative(val)
	return rel ? `${dateStr} (${rel})` : dateStr
}

export { formatThaiBuddhistDate, isToday, formatDateTimeWithRelative, formatRelative }
